import { render, staticRenderFns } from "./DispensationMessagesEscalated.vue?vue&type=template&id=1b0ff884&scoped=true&"
import script from "./DispensationMessagesEscalated.vue?vue&type=script&lang=js&"
export * from "./DispensationMessagesEscalated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0ff884",
  null
  
)

export default component.exports